module.exports = __webpack_public_path__ + "img/map.30fb4549.svg";